Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Gets the value at path of object. If the resolved value is undefined, the defaultValue is returned in its place.
 * @param {object} obj - The object on which to operate
 * @param {string} path - The path to the desired value
 * @param {any} defaultValue - The default value to return if the resolved value is undefined
 * @returns {any}
 */
var get = exports.get = function get(obj, path) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  if (isNullOrEmpty(path)) return defaultValue;

  var keys = path.split('.');
  var current = obj;

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      if (key in current && current[key] !== undefined) {
        current = current[key];
      } else {
        return defaultValue;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return current;
};

/**
 * Checks if path is a direct property of obj
 * @param {object} obj - The object on which to operate
 * @param {string} path - The path to look for
 * @returns {boolean}
 */
var has = exports.has = function has(obj, path) {
  if (isNullOrEmpty(path)) return false;

  var keys = path.split('.');
  var current = obj;

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var key = _step2.value;

      if (key in current) {
        current = current[key];
      } else {
        return false;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return true;
};

/**
 * Returns true if the value is null or undefined.
 * @param {any} x - The item to check
 * @example
 * isNull(null)      // returns true
 * isNull(undefined) // returns true
 * isNull('')        // returns false
 * isNull({})        // returns false
 * isNull([])        // returns false
 * @returns {boolean}
 */
var isNull = exports.isNull = function isNull(x) {
  return x === null || x === undefined;
};

/**
 * Returns true if the value is NOT null or undefined.
 * @param {any} x - The item to check
 * @example
 * isNotNull(null)      // returns false
 * isNotNull(undefined) // returns false
 * isNotNull('')        // returns true
 * isNotNull({})        // returns true
 * isNotNull([])        // returns true
 * @returns {boolean}
 */
var isNotNull = exports.isNotNull = function isNotNull(x) {
  return x !== null && x !== undefined;
};

/**
 * Returns true if the value is null, undefined, or empty.
 * @param {any} x - The item to check
 * @example
 * isNullOrEmpty(null)      // returns true
 * isNullOrEmpty(undefined) // returns true
 * isNullOrEmpty('')        // returns true
 * isNullOrEmpty({})        // returns true
 * isNullOrEmpty([])        // returns true
 * isNullOrEmpty(' ')       // returns false
 * isNullOrEmpty({a: 'b'})  // returns false
 * isNullOrEmpty(['a'])     // returns false
 * isNullOrEmpty(1)         // returns false
 * isNullOrEmpty(true)      // returns false
 * isNullOrEmpty(false)     // returns false
 * isNullOrEmpty(() => {})  // returns false
 * @returns {boolean}
 */
var isNullOrEmpty = exports.isNullOrEmpty = function isNullOrEmpty(x) {
  var type = Array.isArray(x) ? 'array' : typeof x === 'undefined' ? 'undefined' : _typeof(x);
  var isEmpty = function isEmpty() {
    switch (type) {
      case 'string':
      case 'array':
        return x.length <= 0;

      case 'boolean':
      case 'function':
      case 'number':
      case 'symbol':
        return false;

      case 'object':
        return Object.keys(x).length <= 0;

      default:
        return true;
    }
  };
  return isNull(x) || isEmpty();
};

/**
 * Returns true if the value is NOT null, undefined, empty.
 * @param {any} x - The item to check
 * @example
 * isNotNullOrEmpty(null)      // returns false
 * isNotNullOrEmpty(undefined) // returns false
 * isNotNullOrEmpty('')        // returns false
 * isNotNullOrEmpty({})        // returns false
 * isNotNullOrEmpty([])        // returns false
 * isNotNullOrEmpty(' ')       // returns true
 * isNotNullOrEmpty({a: 'b'})  // returns true
 * isNotNullOrEmpty(['a'])     // returns true
 * isNotNullOrEmpty(1)         // returns true
 * isNotNullOrEmpty(true)      // returns true
 * isNotNullOrEmpty(false)     // returns true
 * isNotNullOrEmpty(() => {})  // returns true
 * @returns {boolean}
 */
var isNotNullOrEmpty = exports.isNotNullOrEmpty = function isNotNullOrEmpty(x) {
  var type = Array.isArray(x) ? 'array' : typeof x === 'undefined' ? 'undefined' : _typeof(x);
  var isNotEmpty = function isNotEmpty() {
    switch (type) {
      case 'string':
      case 'array':
        return x.length > 0;

      case 'boolean':
      case 'function':
      case 'number':
      case 'symbol':
        return true;

      case 'object':
        return Object.keys(x).length > 0;

      default:
        return false;
    }
  };

  return isNotNull(x) && isNotEmpty();
};

/**
 * Returns a default value if the check is null
 * @param {any} value - The item to check
 * @param {any} defaultValue - The default value to return if {value} is null
 * @example
 * defaultNull('Hello world!', 'My Default')  // returns 'Hello world!'
 * defaultNull(null, 'My Default')            // returns 'My Default'
 * @returns {any}
 */
var defaultNull = exports.defaultNull = function defaultNull(value, defaultValue) {
  if (isNotNull(value)) {
    return value;
  }

  return defaultValue;
};

/**
 * Returns a string representation of the type which also differentiates between 'object' and 'array'
 * @param {any} x - The item to check
 * @example 
 * typeOf({})             // returns 'object'
 * typeOf([])             // returns 'array'
 * typeOf('Hello world')  // returns 'string'
 * typeOf(7)              // returns 'number' 
 * typeOf(true)           // returns 'boolean' 
 * typeOf(() => {})       // returns 'function'
 * @returns {string} - array, object, string, number, boolean, function...
 */
var typeOf = exports.typeOf = function typeOf(x) {
  if ((typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && Array.isArray(x)) {
    return 'array';
  }

  return typeof x === 'undefined' ? 'undefined' : _typeof(x);
};